import { sendMessageViaChromeRuntime } from 'Environment/BrowserExtension/BrowserExtensionChromeTransport';
import { sendMessageViaContentScript } from 'Environment/BrowserExtension/BrowserExtensionContentScriptTransport';
import { isFirefox, isSafari } from 'Environment/launchResource/device';

export const sendMessageToBrowserExtension =
	isSafari() || isFirefox() ? sendMessageViaContentScript : sendMessageViaChromeRuntime;
